var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',_vm._b({staticClass:"document-link",class:_vm.classes},'a',_vm.$attrs,false),[_c('am-typography',{staticClass:"local-text",attrs:{"variant":"body1","color":"medium"}},[_vm._t("default")],2),_c('span',{staticClass:"local-button"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }